module.exports = __webpack_public_path__ + "static/OpenSans-SemiBold-d72c8183f914b3472bc08fd8327230c8.woff2";